// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiQuantity {
    static getAttributeTypeMap() {
        return PharmacyBiQuantity.attributeTypeMap;
    }
}
PharmacyBiQuantity.discriminator = undefined;
PharmacyBiQuantity.additionalProperties = false;
PharmacyBiQuantity.attributeTypeMap = [
    {
        "name": "priced",
        "baseName": "priced",
        "type": "string"
    },
    {
        "name": "unitDescription",
        "baseName": "unitDescription",
        "type": "string"
    },
    {
        "name": "unitOfMeasure",
        "baseName": "unitOfMeasure",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiQuantity.js.map